import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { StoreProptypes } from "../../PropTypes/StoreProptypes";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";

interface PropTypes {
    setIsExternalLinkTrigger: Function // function to toggle custom trigger
}

// component to render widget custom trigger
const ExternalLinkTriggerPopup = (props: PropTypes) => {

    // Props
    const { setIsExternalLinkTrigger } = props;

    // Redux Data
    const { currentWebsite } = useSelector((store: StoreProptypes) => store);

    // Functions
    const { t } = useTranslation();

    // Stets
    const [customExternalNavigationTrigger, setCustomExternalNavigationTrigger] = useState<boolean>(false);

    // Set current widget icon type
    useEffect(() => {
        // check if current website is available
        if (currentWebsite) {
            // check if custom trigger is turned On
            console.log('currentWebsite.widget_leave_page: ', currentWebsite.widget_leave_page);
            setCustomExternalNavigationTrigger(false)
            if (currentWebsite.widget_leave_page) {
                setCustomExternalNavigationTrigger(currentWebsite.widget_leave_page);
            }
        }
    }, [currentWebsite && currentWebsite.widget_leave_page]);



    // set current statement link in prop function
    useEffect(() => {
        setIsExternalLinkTrigger(customExternalNavigationTrigger);
    }, [customExternalNavigationTrigger]);

    return (
        <>
            <div className="aioa_dashboard-widget-settings-controls">
                <div className={customExternalNavigationTrigger ? "aioa_dashboard-widget-custom-settings" : ''}>
                    <Form.Check
                        type="switch"
                        className="aioa_dashboard-switch"
                        id="custom-trigger-switch"
                        label={`${t('Enable External Link Navigation On Widget')}`}
                        checked={customExternalNavigationTrigger}
                        onChange={(e) => setCustomExternalNavigationTrigger(!customExternalNavigationTrigger)}
                    />
                </div>
            </div>
        </>
    )
}

export default ExternalLinkTriggerPopup;